module.exports = __webpack_public_path__ + "img/kyosha.17d4b0a3.png";